import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-download-link-modal',
  templateUrl: './download-link-modal.component.html',
  styleUrls: ['./download-link-modal.component.scss']
})
export class DownloadLinkModalComponent implements OnInit {

  fileName = '';
  documentLink = '';
  tooltipText = 'Copy Text.';
  @Input() public documentInfo = {};
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    Object.keys(this.documentInfo).forEach((key: string) => {
      this.fileName = key.substr(key.lastIndexOf('/') + 1);
      // @ts-ignore
      this.documentLink = this.documentInfo[key];
    });
  }

  closeModal(): void{
    this.activeModal.close();
  }

  copyText(): void{
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(this.documentLink);
    }else {
      const textArea = document.createElement('textarea');
      textArea.value = this.documentLink;
      // make the textarea out of viewport
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    }
    this.tooltipText = 'Copied';
  }

  changeTooltip(): void{
    this.tooltipText = 'Copy Text.';
  }

}
